/**
 * Created by zad on 17/4/26.
 */
import i18n from 'react-intl-universal';
import { put, call, takeLatest, select } from 'redux-saga/effects';
import { getUserOtpChannelState } from '../reducers/User/UserReducer';
import { User } from '../constants/actionTypes';
import message from '../components/Message';
import ajax from '../utils/ajax';

function* getUserAsync(action) {
  try {
    const { data } = yield call(ajax.getUser);
    yield put({
      type: User.GET_USER_SUCCESS,
      data: {
        can_publish_paid_note: false,
        ...data,
        name: data.nickname,
        email: `${data.slug}@jianshu.com`,
      },
    });
  } catch (e) {
    yield put({ type: User.GET_USER_FAIL });
  }
}

function* getUserOtpChannelAsync(action) {
  const { isForce } = action;
  const optChanel = yield select(getUserOtpChannelState);
  let data = optChanel.get('data');
  try {
    if (!data || isForce) {
      const result = yield call(ajax.getOtpChannel);
      data = result.data; // eslint-disable-line prefer-destructuring
    }
    yield put({ type: User.GET_USER_OTP_CHANNEL_SUCCESS, data });
  } catch (e) {
    yield put({ type: User.GET_USER_OTP_CHANNEL_FAIL });
  }
}

function* changeEditorType(action) {
  const { editorType } = action;
  try {
    yield call(ajax.changeEditorType, editorType);
    yield put({ type: User.CHANGE_EDITOR_TYPE_SUCCESS, editorType });
    message.info(i18n.get('settings.change-editor'));
  } catch (e) {
    yield put({ type: User.CHANGE_EDITOR_TYPE_FAIL });
  }
}

function* switchScrollAsync(action) {
  const { on } = action;
  try {
    yield call(ajax.switchScroll, on);
    message.success(i18n.get('settings.switch-sync-scroll'));
  } catch (e) {
    yield put({ type: User.SWITCH_SYNC_SCROLL_FAIL, on });
  }
}

export function* watchGetUser() {
  yield takeLatest(User.GET_USER, getUserAsync);
}

export function* watchGetUserOtpChannel() {
  yield takeLatest(User.GET_USER_OTP_CHANNEL, getUserOtpChannelAsync);
}

export function* watchChangeEditorType() {
  yield takeLatest(User.CHANGE_EDITOR_TYPE, changeEditorType);
}

export function* watchSwitchScrollAsync() {
  yield takeLatest(User.SWITCH_SYNC_SCROLL, switchScrollAsync);
}



// WEBPACK FOOTER //
// ./src/sagas/UserSaga.js